import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { PodMutation } from '@cast/types-patching-engine';

import { getPodMutationQueryKey } from 'hooks/queries/autoscaler/usePodMutationQuery';
import { getPodMutationsQueryKey } from 'hooks/queries/autoscaler/usePodMutationsQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useCreatePodMutationMutation = (
  onSuccess?: (data: AxiosResponse<PodMutation>) => void
): UseMutationResult<
  AxiosResponse<PodMutation>,
  unknown,
  PodMutation,
  unknown
> => {
  const { currentOrganization } = useOrganizations();
  const { cluster } = useCluster();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (podMutation) =>
      apiClient.autoscaler.createPodMutation({
        clusterId: cluster.id,
        organizationId: currentOrganization!.id,
        podMutation,
      }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: getPodMutationsQueryKey(),
      });
      queryClient.invalidateQueries({
        queryKey: getPodMutationQueryKey(),
      });
      onSuccess?.(data);
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
